import { useEffect } from "react";

const DOMAIN = "https://www.ku-kaihdin.fi";
const DEFAULT_OG_IMAGE = "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/33c0dbd2-f3eb-491c-ab0c-b410b2a3f90f/id-preview-869264d8--4aef8db6-89e8-459d-819d-de87b646191b.lovable.app-1771410170723.png";

interface SEOHeadProps {
  title: string;
  description: string;
  path: string;           // e.g. "/" or "/kaihdin-asennus"
  alternatePath: string;  // e.g. "/en/" or "/en/blind-installation"
  lang?: "fi" | "en";
  ogImage?: string;
}

const setMeta = (attr: string, key: string, content: string) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel: string, key: string, href: string) => {
  const selector = key ? `link[rel="${rel}"][hreflang="${key}"]` : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.querySelector(selector) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (key) el.setAttribute("hreflang", key);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const SEOHead = ({ title, description, path, alternatePath, lang = "fi", ogImage }: SEOHeadProps) => {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;

    const canonicalUrl = `${DOMAIN}${path}`;
    const fiUrl = lang === "fi" ? canonicalUrl : `${DOMAIN}${alternatePath}`;
    const enUrl = lang === "en" ? canonicalUrl : `${DOMAIN}${alternatePath}`;
    const image = ogImage || DEFAULT_OG_IMAGE;
    const locale = lang === "fi" ? "fi_FI" : "en_US";

    // Canonical
    setLink("canonical", "", canonicalUrl);

    // Hreflang
    setLink("alternate", "fi", fiUrl);
    setLink("alternate", "en", enUrl);
    setLink("alternate", "x-default", fiUrl);

    // Meta description
    setMeta("name", "description", description);

    // Open Graph
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonicalUrl);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", image);
    setMeta("property", "og:locale", locale);

    // Twitter
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    return () => {
      document.documentElement.lang = "fi";
    };
  }, [title, description, path, alternatePath, lang, ogImage]);

  return null;
};

export default SEOHead;
